import { useRef, useState, useEffect } from "react";
import DSPrimaryButton from "./DSPrimaryButton";

interface DSCollapsibleTextProps {
  text: string;
  maxLines?: number;
}

const DSCollapsibleText = ({ text, maxLines = 3 }: DSCollapsibleTextProps) => {
  const [expanded, setExpanded] = useState(false);
  const [isLongerThanMaxLines, setIsLongerThanMaxLines] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const textElement = textRef.current;
    if (textElement) {
      setIsLongerThanMaxLines(
        textElement.scrollHeight > textElement.clientHeight,
      );
    }
  }, [text]);

  return (
    <>
      <span
        ref={textRef}
        style={{
          display: "-webkit-box",
          WebkitLineClamp: expanded ? "unset" : maxLines,
          WebkitBoxOrient: "vertical",
          overflow: expanded ? "visible" : "hidden",
          wordBreak: "break-word",
        }}
      >
        {text}
      </span>
      {isLongerThanMaxLines && (
        <DSPrimaryButton
          size="small"
          onClick={() => setExpanded((prev) => !prev)}
          sx={{ p: 0, minWidth: "auto", textTransform: "none", fontSize: 11 }}
        >
          {expanded ? "Show less" : "Show more"}
        </DSPrimaryButton>
      )}
    </>
  );
};

export default DSCollapsibleText;
